module.exports = __webpack_public_path__ + "static/media/custom_ssl.033a98ae.svg";